import React, { useState, useContext, useEffect } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import {
  Button,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Grid,
} from "@material-ui/core";
import { FilledTextField } from "../../components/FormElements";
import { GeofencePackageContext } from "../../context";

const ContentWrap = styled.div`
  opacity: ${(props) => (props.visible ? 1 : 0)};
  transition: opacity 0.2s;
`;

const GeofencePackageVersionForm = ({ handleClose, handleSubmit, visible }) => {
  const { t } = useTranslation();
  const { nextFinalVersion } = useContext(GeofencePackageContext);
  const [version, setVersion] = useState(nextFinalVersion || "");

  useEffect(() => {
    if (nextFinalVersion && !version) setVersion(nextFinalVersion);
  }, [nextFinalVersion]);

  return (
    <ContentWrap visible={visible}>
      <DialogTitle>{t("Fleet.Geofences.ExportModal.GeofenceBinaryModal.Title")}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {t("Fleet.Geofences.ExportModal.GeofenceBinaryModal.Body1")}
          {t("Fleet.Geofences.ExportModal.GeofenceBinaryModal.Body2")}
        </DialogContentText>
        <DialogContentText id="alert-dialog-description">
          {t("Fleet.Geofences.ExportModal.GeofenceBinaryModal.Body3")}
        </DialogContentText>
        <Grid item xs={12}>
          <FilledTextField
            value={version || ""}
            type="text"
            required
            onChange={(e) => setVersion(e.target.value)}
            helperText={t("Fleet.Geofences.ExportModal.GeofenceBinaryModal.VersionHelperText")}
          />
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>{t("Fleet.Geofences.ExportModal.Cancel")}</Button>
        <Button onClick={() => handleSubmit(version)} disabled={version.length <= 6}>
          {t("Fleet.Geofences.ExportModal.GeofenceBinaryModal.Submit")}
        </Button>
      </DialogActions>
    </ContentWrap>
  );
};

GeofencePackageVersionForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
};

GeofencePackageVersionForm.defaultProps = {};

export default GeofencePackageVersionForm;
